import { Logger as clientLogger } from 'beaver-logger'
const logUtil = {}

const createNoopLogger = () => ({
  info: () => {},
  error: () => {},
  track: () => {},
})

let logger = createNoopLogger()

try {
  if (typeof window !== 'undefined' && window.document) {
    logger = clientLogger({
      url: '/dashboard/log',
      logLevel: 'debug',
    })
  }
} catch (err) {
  logger = createNoopLogger()
}

logUtil.info = function (name, data) {
  logger.info(name, data)
}

logUtil.log = function (name, data) {
  logger.info(name, data)
}

logUtil.error = function (name, data) {
  logger.error(name, data)
}

logUtil.track = function (data) {
  logger.track(data)
}

export default logUtil
